export default __webpack_public_path__ + "static/swapp2-83ccdddb4d6de5ba0b21606b831e0061.png";